export enum DnsPageTabs {
  Pools = 'pools',
  Zones = 'zones',
  Records = 'records',
}
